import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, AlertController } from 'ionic-angular';
import { TeamappProvider} from "../../providers/teamapp";
import { UserProvider} from "../../providers/user";
import {ImageProvider} from "../../providers/image";
import { ChatGroupAddMemberPage} from "../chat-group-add-member/chat-group-add-member";
import { Camera } from '@ionic-native/camera';
/**
 * Generated class for the ChatGroupInfoPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-chat-group-info',
  templateUrl: 'chat-group-info.html',
})
export class ChatGroupInfoPage {

  groupId: any = [];
  group: any = [];

  constructor(
      public navCtrl: NavController,
      public navParams: NavParams,
      public teamappProvider: TeamappProvider,
      public userProvider: UserProvider,
      public alertCtrl: AlertController,
      public imageProvider: ImageProvider,
      public camera: Camera
  )
  {
    this.groupId = this.navParams.get('group');
    this.loadGroupInfo();
  }

  ionViewDidEnter() {
    this.loadGroupInfo();
  }

  ionViewWillLeave() {

  }

  loadGroupInfo() {
    this.teamappProvider.http_request('action=get_group_info&single_target='+this.groupId, 'chat', false, true).then(data => {
      console.log('group info');
      console.log(data);
      this.group = data;
    });
  }

  remove(member: any) {
    this.teamappProvider.http_request('action=remove_member_from_group&single_target='+member.token+'&content='+this.groupId, 'chat', false, true).then(data => {
      this.loadGroupInfo();
    });
  }

  isAdmin() {
    if(this.group.member) {
      for(let i = 0;i<this.group.member.length; i++) {
        if(this.group.member[i].token == this.userProvider.getUserID() && this.group.member[i].admin == 1) {
          return true;
        }
      }
    }
    return false;
  }

  viewUser(member: any) {

  }

  addMembers() {
    this.navCtrl.push(ChatGroupAddMemberPage, {
      group: {
        groupId: this.groupId,
        member: this.group.member
      }
    });
  }

  leaveGroup() {

  }

  deleteGroup() {
    this.teamappProvider.http_request('action=delete_group&single_target='+this.groupId, 'chat', false, true).then(data => {
      this.navCtrl.pop();
    });
  }

  addAll() {
    let alert = this.alertCtrl.create({
      title: 'Einladung',
      message: "Jetzt alle Chat-Mitglieder einladen?",
      buttons: [
        {
          text: 'Nein',
          handler: data => { }
        },
        {
          text: 'Ja',
          handler: data => {
            this.teamappProvider.http_request('action=add_all_member_to_group&content='+this.groupId, 'chat', false, true).then(data => {
              this.loadGroupInfo();
            });
          }
        }
      ]
    }).present();
  }

  setName() {
    let alert = this.alertCtrl.create({
      title: 'Gruppennamen Ändern',
      message: "Bitte schreibe einen neuen Gruppennamen.",
      inputs: [
        {
          name: 'name',
          placeholder: 'Name',
          value: this.group.name
        }
      ],
      buttons: [
        {
          text: 'Abbrechen',
          handler: data => { }
        },
        {
          text: 'Speichern',
          handler: data => {
            let name = data["name"];
            if (this.group.name != name) {
              this.teamappProvider.http_request('action=set_group_name&single_target='+this.groupId+'&content='+name, 'chat', false, true).then(data => {
                this.loadGroupInfo();

                this.alertCtrl.create({
                  title: 'Gruppennamen Ändern',
                  message: "Die Gruppenbeschreibung wurde erfolgreich geändert!",
                  buttons: [
                    {
                      text: 'Ok',
                      handler: data => { }
                    }
                  ]
                }).present();

              });
            }
          }
        }
      ]
    }).present();
  }

  setDescription() {
    let alert = this.alertCtrl.create({
      title: 'Gruppenbeschreibung Ändern',
      message: "Bitte schreibe eine neue Gruppenbeschreibung.",
      inputs: [
        {
          name: 'description',
          placeholder: 'Beschreibung',
          value: this.group.description
        }
      ],
      buttons: [
        {
          text: 'Abbrechen',
          handler: data => { }
        },
        {
          text: 'Speichern',
          handler: data => {
            let description = data["description"];
            if (this.group.description != description) {
              this.teamappProvider.http_request('action=set_group_description&single_target='+this.groupId+'&content='+description, 'chat', false, true).then(data => {
                this.loadGroupInfo();

                this.alertCtrl.create({
                  title: 'Gruppenbeschreibung Ändern',
                  message: "Die Gruppenbeschreibung wurde erfolgreich geändert!",
                  buttons: [
                    {
                      text: 'Ok',
                      handler: data => { }
                    }
                  ]
                }).present();

              });
            }
          }
        }
      ]
    }).present();
  }


  setPhoto() {
    console.log('setPhoto click');
    // Ask if the user wants to take a photo or choose from photo gallery.
    this.alertCtrl.create({
      title: 'Gruppenbild ändern',
      message: 'Neues Gruppenbild auswählen oder ein Bild aufnehmen?',
      buttons: [
        {
          text: 'Abbrechen',
          handler: data => { }
        },
        {
          text: 'Aus der Galerie auswählen',
          handler: () => {
            // Call imageProvider to process, upload, and update user photo.
            this.imageProvider.setGroupPhoto(this.groupId, this.camera.PictureSourceType.PHOTOLIBRARY).then(url => {
              console.log("IMAGE URL:");
              console.log(url);
              this.loadGroupInfo();
            });

          }
        },
        {
          text: 'Bild aufnehmen',
          handler: () => {
            this.imageProvider.setGroupPhoto(this.groupId, this.camera.PictureSourceType.CAMERA).then(url => {
              console.log("IMAGE URL:");
              console.log(url);
              this.loadGroupInfo();
            });
          }
        }
      ]
    }).present();

  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ChatGroupInfoPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/chat-group-info/chat-group-info.ts